"use client";
import { PublicationLogosComponent } from "./publication-logos";
import { AlumniCompaniesSection } from "./alumni-companies-section";
import { AIRealitySection } from "./ai-reality-section";
import { OurApproachSection } from "./our-approach-section";
import { WhatYouLearnSection } from "./what-you-learn-section";
import { HeroSection } from "./hero-section";
import { MissionSection } from "./mission-section";
import { RightForYouSection } from "./right-for-you-section";
import { CallToActionSection } from "./call-to-action-section";
import { TopTestimonialsSection } from "./top-testimonials-section";
import { TeamBridgeSection } from "./team-bridge-section";
import { ProgramPathwaySection } from "./program-pathway-section";

export const HomeBody = () => {
  return (
    <div className="flex flex-col min-h-[100dvh]">
      <main className="flex-1">
        <HeroSection />
        
        <TopTestimonialsSection />

        {/* WL Handoff Banner */}
        <div className="py-4 text-center bg-foreground/5 border-y border-border/20">
          <p className="text-sm text-muted-foreground">
            Part of the{" "}
            <a
              href="https://www.workplacelabs.io"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-foreground hover:text-primary transition-colors underline underline-offset-4"
            >
              Workplace Labs
            </a>{" "}
            ecosystem — where behavioral science meets AI adoption.
          </p>
        </div>

        <section className="container-class bg-foreground">
          <AIRealitySection />
        </section>

        
        
        <section className="bg-foreground container-class py-8 md:py-12 lg:py-16">
          <OurApproachSection />
          <PublicationLogosComponent />
        </section>

        <section className="container-class py-8 md:py-12 lg:py-16">
          <WhatYouLearnSection />
        </section>

        <RightForYouSection />

        <section className="container-class bg-foreground py-0">
          <AlumniCompaniesSection />
        </section>
        
        <TeamBridgeSection />

        <ProgramPathwaySection />
        <CallToActionSection />
      </main>
    </div>
  );
};
